import { 
  MapPin, Camera, Utensils, Car, Hotel, ShoppingBag, Coffee, Building2, MapPinned, Plus 
} from 'lucide-react';

// Category configuration
export const CATEGORIES = {
  activity: { label: 'Atividade', icon: Camera, color: 'bg-purple-500' },
  meal: { label: 'Refeição', icon: Utensils, color: 'bg-orange-500' },
  transport: { label: 'Transporte', icon: Car, color: 'bg-blue-500' },
  accommodation: { label: 'Hospedagem', icon: Hotel, color: 'bg-green-500' },
  shopping: { label: 'Compras', icon: ShoppingBag, color: 'bg-pink-500' },
  free_time: { label: 'Tempo Livre', icon: Coffee, color: 'bg-slate-500' },
  other: { label: 'Outro', icon: MapPin, color: 'bg-gray-500' },
};

// POI types for nearby search
export const POI_TYPES = [
  { value: 'restaurant', label: 'Restaurantes', icon: Utensils },
  { value: 'lodging', label: 'Hospedagem', icon: Hotel },
  { value: 'tourist_attraction', label: 'Atrações', icon: Camera },
  { value: 'cafe', label: 'Cafés', icon: Coffee },
  { value: 'bar', label: 'Bares', icon: Utensils },
  { value: 'shopping_mall', label: 'Shopping', icon: ShoppingBag },
  { value: 'museum', label: 'Museus', icon: Building2 },
  { value: 'park', label: 'Parques', icon: MapPinned },
  { value: 'gas_station', label: 'Postos', icon: Car },
  { value: 'pharmacy', label: 'Farmácias', icon: Plus },
];

// Map container style
export const mapContainerStyle = {
  width: '100%',
  height: '200px',
  borderRadius: '8px',
};

// Map dark theme styles
export const mapDarkStyles = [
  { elementType: 'geometry', stylers: [{ color: '#1e293b' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1e293b' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#94a3b8' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#334155' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0f172a' }] },
];
